// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1YHet","buttons":"RemoveExpirationActionButtons_buttons__3UK53"};